import MuiIconButton from '@mui/material/IconButton'

import { getIconButtonStyles } from './IconButton.styles'
import styles from './IconButton.module.scss'

export interface IconButtonProps {
  icon: string | React.ReactNode
  onClick: (() => void) | ((event: React.MouseEvent<HTMLElement>) => void)
  color: 'primary' | 'secondary' | 'tertiary'
  disabled?: boolean
  rotate?: number
  flip?: boolean
  noPadding?: boolean
  variant?: 'text' | 'contained'
}

function IconButton(props: IconButtonProps) {
  const {
    icon,
    onClick,
    color,
    disabled = false,
    rotate,
    flip,
    noPadding,
    variant = 'text'
  } = props
  const IconButtonStyles = getIconButtonStyles({ color, variant })

  return (
    <MuiIconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...IconButtonStyles,
        padding: noPadding ? 0 : '0.5rem',
        '&:focus': {
          outline: 'none'
        },
        rotate: rotate ? `${rotate}deg` : '0deg',
        transform: flip ? 'scaleX(-1)' : 'none',
        height: 'fit-content',
        width: 'fit-content'
      }}
      disableRipple
    >
      {typeof icon === 'string' ? (
        <i className={`${icon} ${styles.iconComponent}`} />
      ) : (
        icon
      )}
    </MuiIconButton>
  )
}

export default IconButton
